<template>
  <div class="leftrail-main-box">
    <a-menu
      :default-selected-keys="['1']"
      v-model="current"
      mode="inline"
      @click="handleClick"
    >
      <a-menu-item key="1"> <a-icon type="bank" />工作台</a-menu-item>
      <a-menu-item key="2" v-if="getUserInfo.role !== 'company'">
        <a-icon type="user" />个人信息</a-menu-item
      >
      <a-menu-item key="3" v-if="getUserInfo.role !== 'company'">
        <a-icon type="solution" />报名管理</a-menu-item
      >
      <a-menu-item key="4" v-if="getUserInfo.role !== 'company'">
        <a-icon type="cluster" />考试管理</a-menu-item
      >
      <a-menu-item key="5" v-if="getUserInfo.role !== 'company'">
        <a-icon type="monitor" />证书查询</a-menu-item
      >
      <a-menu-item key="6" v-if="getUserInfo.role == 'company'">
        <a-icon type="solution" />企业基本信息</a-menu-item
      >
      <a-menu-item key="7" v-if="getUserInfo.role == 'company'">
        <a-icon type="cluster" />员工管理</a-menu-item
      >
    </a-menu>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'mainLeftRail',
  data() {
    return {
      current: ['1'],
    }
  },
  watch: {
    $route: {
      handler(val) {
        switch (val.fullPath) {
          case '/workTable':
            this.current = ['1']
            break
          case '/personalInformation':
            this.current = ['2']
            break
          case '/applyManage':
            this.current = ['3']
            break
          case '/examManage':
            this.current = ['4']
            break
          case '/certificateManage':
            this.current = ['5']
            break
          case '/companyBaseMessage':
            this.current = ['6']
            break
          case '/emptyManage':
            this.current = ['7']
            break
        }
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters(['getUserInfo']),
  },

  methods: {
    handleClick(e) {
      switch (e.key) {
        case '1':
          this.$router.push('/workTable')
          break
        case '2':
          this.$router.push('/personalInformation')
          break
        case '3':
          this.getUserPermission()
          this.$router.push('/applyManage')
          break
        case '4':
          this.getUserPermission()
          this.$router.push('/examManage')
          break
        case '5':
          this.getUserPermission()
          this.$router.push('/certificateManage')
          break

        case '6':
          this.$router.push('/companyBaseMessage')
          break
        case '7':
          this.getCompanyPermission()

          this.$router.push('/emptyManage')
          break
      }
    },
    getUserPermission() {
      let handleUserInfo = {
        accountId: this.getUserInfo.accountId,
        city: this.getUserInfo.city,
        companyName: this.getUserInfo.companyName,
        email: this.getUserInfo.email,
        hxtId: this.getUserInfo.hxtId,
        id: this.getUserInfo.id,
        idCard: this.getUserInfo.idCard,
        mobile: this.getUserInfo.mobile,
        name: this.getUserInfo.name,
        orgId: this.getUserInfo.orgId,
        orgType: this.getUserInfo.orgType,
        realNameCheck: this.getUserInfo.realNameCheck,
      }

      let userArrary = Object.values(handleUserInfo)

      userArrary.forEach((item) => {
        if (!item) {
          this.$message.error('请完善个人信息，若未实名认证则需进行实名认证')
          throw new Error('请完善个人信息，若未实名认证则需进行实名认证')
        }
      })
    },
    getCompanyPermission() {
      console.log(this.getUserInfo.status)
      if (this.getUserInfo.status == 0) {
        this.$message.error('当前您的企业注册申请尚未被审核')
        throw new Error('当前您的企业注册申请尚未审核')
      } else if (this.getUserInfo.status == 2) {
        this.$message.error('当前您的企业注册申请未通过')
        throw new Error('当前您的企业注册申请未通过')
      }

      // console.log(this.getUserInfo, Object.values(this.getUserInfo))
    },
  },
}
</script>

<style scoped lang="less">
.leftrail-main-box {
  width: 100%;

  /deep/.ant-menu-item {
    text-align: left;
    padding-left: 42px !important;
  }

  /deep/.ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
    background-color: #3c6aff;
    color: #fff;
  }
}
</style>
